import { ComponentType } from "react";
import { FallbackProps } from "react-error-boundary";
import { handleApiError } from "../../helpers";

export const ErrorFallback: ComponentType<FallbackProps> = ({ error, resetErrorBoundary }) => {

  return (
    <div className="card">
      <div className="d-flex justify-content-center align-item-center card-body">
        <div className="text-center pt-20 pb-20">
          <p className="text-muted ms-20p me-20p pt-3 pb-3">
            {error.message === "Network Error"
              ? "Network Error. Please ensure you have an internet connection, and try again."
              : handleApiError(error)}
          </p>
          <button
            onClick={resetErrorBoundary}
            className="btn  btn-bg-light btn-active-color-primary btn-sm me-1 text-muted fw-bold"
          >
            <span className="fw-bolder">Refresh</span>
          </button>
        </div>
      </div>
    </div>
  );
};
